export default __webpack_public_path__ + "static/assets/95a83bd24f55a31899c4618d519abedd.svg";